<template>
  <div class="relative group">
    <div :class="cardClasses">
      <!-- Header Slot -->
      <div
        v-if="$slots.header"
        class="flex items-start justify-between gap-3 mb-3"
      >
        <slot name="header" />
      </div>

      <div
        v-if="$slots.content"
        class="mt-3 first:mt-0"
      >
        <slot name="content" />
      </div>

      <div
        v-if="$slots.footer"
        class="mt-3 first:mt-0"
      >
        <slot name="footer" />
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
// TimelineCard component with slots for header, content, and footer

const cardClasses = computed(() => [
  'min-w-0 flex-1 rounded-xl border border-slate-200/70 bg-white/75',
  'p-[0.95rem] backdrop-blur-[10px] transition-all duration-150 ease-in-out',
  'shadow-[0_1px_1px_rgba(15,23,42,0.04),0_10px_30px_rgba(15,23,42,0.06)]',
  'hover:-translate-y-0.5 hover:border-slate-300/70 hover:bg-slate-50/85',
  'hover:shadow-[0_1px_1px_rgba(15,23,42,0.05),0_18px_45px_rgba(15,23,42,0.09)]',
  'sm:p-3.5',
].join(' '))
</script>
